module.exports = "/_next/static/images/package-b180da888513608d85220174316cfdeb.svg";